<template>
  <path
    d="M20 13.0002H3C2.45 13.0002 2 13.4502 2 14.0002V20.0002C2 20.5502 2.45 21.0002 3 21.0002H20C20.55 21.0002 21 20.5502 21 20.0002V14.0002C21 13.4502 20.55 13.0002 20 13.0002ZM20 3.00024H3C2.45 3.00024 2 3.45024 2 4.00024V10.0002C2 10.5502 2.45 11.0002 3 11.0002H20C20.55 11.0002 21 10.5502 21 10.0002V4.00024C21 3.45024 20.55 3.00024 20 3.00024Z"
  />
</template>
